import { gql } from '@apollo/client';
import upperFirst from 'lodash.upperfirst';
const defaultSchemaProps = `
  id
  identifier
  properties
  dynamicProperties
  actions
  interfaces
  relations
  __typename
`;
const getSearchPublishedContent = fields => gql`
    query searchPublishedContent($rawQueryStringified: String!, $offset: Int, $limit: Int, $sort: String) {
      searchPublishedContent(rawQueryStringified: $rawQueryStringified, offset: $offset, limit: $limit, sort: $sort) {
        ${fields}
      }
    }
  `;
const getUser = userProps => gql`
  query getUser($id: String!) {
    getUser(id: $id) {
      id
      ${userProps}
    }
  }
`;
const getCurrentUser = userProps => gql`
  query {
    getUser: getCurrentUser {
      id
      ${userProps}
    }
  }
`;
const getEntitySchema = gql`
  query getEntitySchemas($identifier: String!) {
    getEntitySchemas(identifier: $identifier) {
      ${defaultSchemaProps}
    }
  }
`;
const getSingleEntitySchema = gql`
  query getEntitySchema($id: String!) {
    getEntitySchema: getEntitySchema(id: $id) {
      ${defaultSchemaProps}
    }
  }
`;
const getRecordParents = queryName => gql`
query getRecordParents($id: String!){
  recordParents: ${queryName}(id: $id){
    id,
    name,
    url,
    parents {
      id,
      name
      url
    }
  }
}`;
const getMultipleSchema = identifiers => {
  const queryString = identifiers.map(id => `${id}: getEntitySchema(id: "${id}") {
            ${defaultSchemaProps}
      }`).join(`\n`);
  return gql`
    query {
      ${queryString}
    }`;
};
const getFiles = gql`
  query getFiles($where: JSON!) {
    getFiles(where: $where) {
      id
      url
      data
    }
  }
`;
const getFileById = gql`
  query getFile($id: String!) {
    getFile(id: $id) {
      id
      url
      data
    }
  }
`;
const getCount = action => gql`query countData($where: JSON!) {
    ${action} (where: $where)
  }
`;
const generateQuery = (action, props) => `
  query getEntityData(
    $where: JSON
    $limit: Int
    $offset: Int
    $sort: [${upperFirst(action)}SortItem]){
    ${action} (where: $where, limit: $limit, offset: $offset, sort: $sort){
      ${props}
      id
      __typename
    }
  }
  `;
const generateMultiItemQuery = (action, props) => gql`
  query getEntityData($where: JSON){
    ${action} (where: $where){
      ${props}
      id
      __typename
    }
  }
  `;
const generateSingleItemQuery = (action, props) => gql`
  query getEntityData($id: String!){
    entityData: ${action}(id: $id){
    ${props},
    id,
    __typename
    }
  }
  `;

// TODO: extend function to handle properties and make them dynamic with a config schema for each entity.
const getAction = (action, props) => {
  const query = generateQuery(action, props);
  return gql`
    ${query}
  `;
};
const getItemList = gql`
  query getItemList($id: String!) {
    getItemList(id: $id) {
      id
      listItems {
        itemId
        itemEntity
      }
    }
  }
`;
const addItemsToList = gql`
  mutation addItemsToList(
    $name: String!
    $id: String
    $listItems: [AddItemsToListInputListItemsItem]!
  ) {
    addItemsToList(input: { name: $name, id: $id, listItems: $listItems }) {
      result {
        id
        listItems {
          itemId
          itemEntity
        }
      }
    }
  }
`;
const removeItemsFromList = gql`
  mutation removeItemsFromList(
    $listId: String!
    $listItems: [RemoveItemsFromListInputListItemsItem]!
  ) {
    removeItemsFromList(input: { id: $listId, listItems: $listItems }) {
      result {
        id
        listItems {
          itemId
          itemEntity
        }
      }
    }
  }
`;
export { getEntitySchema, getSingleEntitySchema, getAction, getFiles, getFileById, generateMultiItemQuery, generateSingleItemQuery, getSearchPublishedContent, getCount, getMultipleSchema, getUser, getRecordParents, getItemList, addItemsToList, removeItemsFromList, getCurrentUser };
//# sourceMappingURL=index.js.map